import clsx from 'clsx';

export const DetailsPageCardsSkeleton = () => {
	return (
		<div className="my-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
			{Array.from({ length: 3 }).map((_, idx) => (
				<div key={idx} className="animate-pulse rounded-lg bg-white p-4 sm:p-8 shadow-md">
					<div className="mb-6 flex items-center gap-3">
						<div className="h-6 w-6 rounded-full bg-gray-200"></div>
						<div className="h-5 w-24 rounded bg-gray-200"></div>
					</div>

					<div
						className={clsx('flex justify-between', {
							'!justify-center': idx === 1
						})}
					>
						<div
							className={clsx('flex flex-col gap-4', {
								'items-center': idx === 1
							})}
						>
							<div className="h-4 w-32 rounded bg-gray-200"></div>
							<div className="h-4 w-24 rounded bg-gray-200"></div>
							<div className="h-4 w-28 rounded bg-gray-200"></div>
						</div>
						{!idx && (
							<div className="flex flex-col gap-4">
								<div className="h-4 w-32 rounded bg-gray-200"></div>
								<div className="h-4 w-24 rounded bg-gray-200"></div>
								<div className="h-4 w-28 rounded bg-gray-200"></div>
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	);
};
